import { CSSProperties } from "react";
import style from "./pickers.module.css";
import classNames from "classnames";
import * as Select from "frontend/ui-components/select/select";
import { RequiredFieldMark } from "./required-field-mark";
import { MondayColumn } from "shared/integrations/mapper";

export function StatusColumnPicker({
  column,
  selected,
  setSelected,
}: {
  column: MondayColumn;
  selected: string;
  setSelected: (value: string) => void;
}) {
  const settings = column.settings;
  const labels = settings?.labels ?? {};
  const colors = settings?.labels_colors ?? {};
  const statusIds = Object.keys(labels);

  function renderMainLabel() {
    if (labels[selected]) {
      return (
        <div
          className={classNames(style.statusTag, style.statusOptionAlone)}
          style={{ backgroundColor: colors[selected].color }}
        >
          {labels[selected]}
        </div>
      );
    } else {
      return (
        <div title={column.title} className={style.cropText}>
          Choose value
          {column.required && <RequiredFieldMark />}
        </div>
      );
    }
  }

  const theme = "dark";

  return (
    <Select.Select selectedId={selected} setSelectedId={setSelected}>
      <Select.Trigger customClass={classNames(style.selectTrigger, style[theme])}>
        {renderMainLabel()}
        <Select.Arrow theme={theme} />
      </Select.Trigger>
      <Select.Popover className={classNames(style.background, style.popover, style.rounded, style[theme])}>
        <Select.OptionsList>
          <div className={style.popoverChildren} style={{ "--stack-gap": "5px" } as CSSProperties}>
            {statusIds.map((id) => (
              <Select.Option id={id} key={id}>
                <div className={style.statusOptionItem} style={{ backgroundColor: colors[id].color }}>
                  {labels[id]}
                </div>
              </Select.Option>
            ))}
          </div>
        </Select.OptionsList>
      </Select.Popover>
    </Select.Select>
  );
}
